export const GOLD = "Gold"
export const GREEN = "Green"
